import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import Color from 'color';
import { Modal } from './Modal';
import { Golfbox } from './Golfbox';
import { theme, color } from '../theme';
import { useSize, vr } from '../utils';

import SearchIcon from '../img/search.inline.svg';
import GolfboxIcon from '../img/golfbox.inline.svg';
import EnglishIcon from '../img/english.inline.svg';
import ProshopIcon from '../img/proshop.inline.svg';
import RestaurantIcon from '../img/restaurant.inline.svg';

export function TopBar() {
  const [ modalIsOpen, setIsOpen ] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  // }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Bar role="navigation" aria-label="Sekundær menu" id="top" data-font="body">
      <div className="container">
        <Link to="/soegning/" aria-label="Søg på hjemmesiden">
          <SearchIcon className="icon search-icon" />
          <span>Søgning</span>
        </Link>
        <button type="button" onClick={() => openModal()} aria-label="Login på Golfbox">
          <GolfboxIcon className="icon golfbox-icon" />
          <span>GolfBox</span>
        </button>
        <a href="https://www.restaurantsgk.dk/" aria-label="Besøg Restaurant SGKs hjemmeside" target="_BLANK" rel="noreferrer">
          <RestaurantIcon className="icon" />
          <span>Restaurant</span>
        </a>
        <a href="https://www.cpg.dk/" aria-label="Besøg ProShoppens hjemmeside" target="_BLANK" rel="noreferrer">
          <ProshopIcon className="icon" />
          <span>Proshop</span>
        </a>
        <Link to="/english" aria-label="Go to page in English" lang="en">
          <EnglishIcon className="icon english-icon" />
          <span>English</span>
        </Link>
      </div>
      <Modal isOpen={modalIsOpen} closeModal={closeModal} fullWidth={false} style={{ width: '90vw', maxWidth: 850 }}>
        <Golfbox />
      </Modal>
    </Bar>
  );
}

const brown = Color(color.brown).lighten(0.2).desaturate(0.2);
// const { brown } = color;

const Bar = styled.nav`
  height: ${theme.headerTopBarHeight};
  width: 100%;
  /* margin-bottom: ${useSize(theme.headerContainerHeight) - useSize(theme.headerHeight) - useSize(theme.headerTopBarHeight)}px; */
  background: ${theme.headerTopBarBackgroundColor};
  order: 0;
  /* overflow: hidden; */

  span {
    display: none;
  }

  .icon {
    order: 0;
  }

  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .icon {
    width: ${theme.headerTopBarIconSize};
    height: ${theme.headerTopBarIconSize};
    position: relative;
    opacity: .9;
    /* display: none; */

    svg {
      height: inherit;
      width: inherit;
    }

    /* top: 2px; */
    /* display: none; */

    .st0, .st2, .st3 {
      fill: ${brown};
    }

    .s0 {
      stroke-color: ${brown};
    }

    .f0 {
      fill: ${brown};
    }

    .st1 { fill: ${color.white} }
  }
  
  a, button {
    font-size: 0.7rem;
    line-height: ${theme.headerTopBarHeight};
    height: ${theme.headerTopBarHeight};
    /* letter-spacing: 0.025em; */
    display: flex;
    flex-direction: row;
    align-items: center;
    /* text-transform: uppercase; */
    font-weight: 500;
    font-family: inherit;
    text-decoration: none;
    position: relative;
    appearance: none;
    border: 0;
    background: transparent;
    color: ${Color(color.brown).lighten(0.8).desaturate(0.6)};
    opacity: .8;
    padding: 0;
    cursor: pointer;
    
    &:hover {
      color: ${color.brown};
      opacity: 1;
      /* background: ${theme.headerBackgroundColor}; */

      .icon {
        opacity: 1;

        .f0 { fill: ${color.brown} }
        .st2 { fill: ${color.red} }
        .st3 { fill: ${color.darkblue} }
      }
    }
  }

  a, .icon, .st0, .st1, .st2 {
    /* transition: ${theme.transitionShortAndFunction}; */
  }

  @media (min-width: 460px) {
    .container {
      justify-content: flex-end;
    }

    a, button {
      margin-left: ${vr(0.75)};
    }

    .icon {
      margin-right: ${vr(0.25)};
    }

    span {
      display: inline;
    }
  }
`;
